var _g, _path, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175.95mm",
    height: "157.55mm",
    viewBox: "0 0 175.95 157.55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.26852 -13.796)",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.812 93.567c-3.0251-12.395 2.8051-23.883 13.022-25.658 4.9064-0.85257 10.189 0.69434 14.685 4.3004 4.4966 3.6061 7.8388 8.9759 9.2916 14.928 3.0251 12.395-2.8051 23.883-13.022 25.658-10.217 1.7754-20.952-6.8336-23.977-19.229z",
    strokeWidth: 1.1906
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.812 93.567c-3.0251-12.395 2.8051-23.883 13.022-25.658 4.9064-0.85257 10.189 0.69434 14.685 4.3004 4.4966 3.6061 7.8388 8.9759 9.2916 14.928 3.0251 12.395-2.8051 23.883-13.022 25.658-10.217 1.7754-20.952-6.8336-23.977-19.229z",
    stroke: "#f67535",
    strokeLinejoin: "round",
    strokeWidth: 4.7625
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.835 73.291c1.9024 6.3093 12.418 22.762 11.414 37.856-1.004 15.093-24.678 45.525-17.438 52.704 7.2396 7.1788 49.726-3.1658 60.876-9.6312s-3.2235-13.198 6.0242-29.161 43.544-55.692 49.462-66.616c5.9185-10.924-4.756-7.8476-13.951 1.0701-9.1949 8.9178-30.015 44.366-41.218 52.437-11.203 8.0706-17.914 4.9494-25.999-4.013-8.0851-8.9624-16.646-40.531-22.511-49.761-5.8657-9.2299-11.678-8.4942-12.683-5.6182-1.004 2.876 5.5486 19.062 6.6583 22.874",
    strokeWidth: 1.1906
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.835 73.291c1.9024 6.3093 12.418 22.762 11.414 37.856-1.004 15.093-24.678 45.525-17.438 52.704 7.2396 7.1788 49.726-3.1658 60.876-9.6312s-3.2235-13.198 6.0242-29.161 43.544-55.692 49.462-66.616c5.9185-10.924-4.756-7.8476-13.951 1.0701-9.1949 8.9178-30.015 44.366-41.218 52.437-11.203 8.0706-17.914 4.9494-25.999-4.013-8.0851-8.9624-16.646-40.531-22.511-49.761-5.8657-9.2299-11.678-8.4942-12.683-5.6182-1.004 2.876 5.5486 19.062 6.6583 22.874",
    stroke: "#f67535",
    strokeLinejoin: "round",
    strokeWidth: 4.7625
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.68 138.7-161.71 32.643",
    strokeWidth: 1.1906
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.975 32.895 1.1968 123.89",
    fillRule: "evenodd",
    stroke: "#f67535",
    strokeLinejoin: "round",
    strokeWidth: 4.1418
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.26852 -13.796)",
    fillRule: "evenodd",
    stroke: "#f67535",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160.17 44.037-1.106 124.69",
    strokeWidth: 4.1546
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.291 51.389 82.269-36.326",
    strokeWidth: 2.7704
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.66 48.118-79.632-33.055",
    strokeWidth: 2.696
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.b78a322ecc37e74d90c6170a6879e0ee.svg";
export { ForwardRef as ReactComponent };